import React from 'react';
function FormItemIcon(_a) {
    var icon = _a.icon;
    if (icon) {
        return React.createElement("div", { className: "elmo-formitem__icon" }, icon);
    }
    return null;
}
export default FormItemIcon;
